import { fundStatusMap, payMethodsMap } from './const';

interface Item {
  currency: string;
  amount: string;
  status: string;
  method: string;
  submitTime: string;
}

interface Props {
  data: Item;
}

export const FundCard = (props: Props) => {
  return (
    <div class="border-b margin-x padding-y">
      <div class="flex justify-space-between">
        <div class="flex">
          +{props.data.amount}
          <div>{props.data.currency}</div>
        </div>
        <div>{fundStatusMap[props.data.status]}</div>
      </div>
      <div>{payMethodsMap[props.data.method]}</div>
      <div>{props.data.submitTime}</div>
    </div>
  );
};
